import { useMediaQueries } from "@react-hook/media-query";
import React, { Fragment } from "react";
import style from "./partner_insurer_carousel.module.css";
import Carousel from "react-elastic-carousel";

export default function PartnerInsurerCarousel() {
  const partnerList = [
    {
      id: 1,
      imageAlt: "วิิริยะประกันภัย",
      image: "/assets/images/partners/viriya.png",
    },
    {
      id: 2,
      title: "ไทยวิวัฒ",
      image: "/assets/images/partners/thaivivat.png",
    },
    {
      id: 3,
      title: "เมืองไทยปประกันชีวิต",
      image: "/assets/images/partners/muangthai.png",
    },
    {
      id: 4,
      title: "Aliance ayudhya",
      image: "/assets/images/partners/alliance.png",
    },
    {
      id: 5,
      title: "msig",
      image: "/assets/images/partners/msig.png",
    },
    {
      id: 6,
      title: "Aioi Bangkok",
      image: "/assets/images/partners/aioi.png",
    },
    {
      id: 7,
      title: "Cigna",
      image: "/assets/images/partners/cigna.png",
    },
    {
      id: 8,
      title: "กรุงเเทพประกันภัย",
      image: "/assets/images/partners/bangkok.png",
    },
  ];
  const mobile = useMediaQueries({
    screen: "screen",
    min: "(min-width: 0px)",
    max: "(max-width: 1023px)",
  });
  const monitor = useMediaQueries({
    screen: "screen",
    min: "(min-width: 1024px)",
  });
  const noArrow = ({ type, onClick, isEdge }) => {
    return <Fragment></Fragment>;
  };
  return (
    <Fragment>
      <div className={style.partner_insurer_carousel}>
        <div className={style.title}>
          <h2>แผนประกันจากเหล่าพันธมิตรชั้นนำกว่า 40 แห่ง</h2>
        </div>
        {mobile.matchesAll && (
          <Carousel
            outerSpacing={-10}
            renderArrow={noArrow}
            itemsToShow={4}
            itemPadding={[16, 16]}
            className={style.carousel_slider_container}
          >
            {partnerList.map((_partner, index) => {
               if (index % 2 === 0) 
               return (
                <div
                  key={index}
                  className={style.partner_col}
                >
                  <div className={style.partner_card}>
                    <div className={style.partner_image_wrapper}>
                      <a href="#" target={"_blank"} rel="noreferrer">
                        <img src={partnerList[index].image} />
                      </a>
                    </div>
                  </div>
                  <div className={style.partner_card}>
                    <div className={style.partner_image_wrapper}>
                      <a href="#" target={"_blank"} rel="noreferrer">
                        <img src={partnerList[index+1].image} />
                      </a>
                    </div>
                  </div>
                </div>
               ) 
              }   
            )}
          </Carousel>
        )}
        {monitor.matchesAll && (
          <Carousel
            outerSpacing={-10}
            itemsToShow={8}
            itemPadding={[24, 24]}
            className={style.carousel_slider_container}
        >
          {partnerList.map((partner) => (
            <div
              key={partner.id}
              className={style.partner_card}
            >
              <div className={style.partner_image_wrapper}>
                <a href="#" target={"_blank"} rel="noreferrer">
                  <img src={partner.image} />
                </a>
              </div>
            </div>
          ))}
          </Carousel>
        )}
      </div>
    </Fragment>
  );
}
